import { useState, useEffect } from "react";
import DashboardCards from "./Card";
import MaritalStatusChart from "../DashboardComponent/Graph/MaritalLineChart";
import GenderPieChart from "./Graph/GenderPieChart";
import AgeGroupChart from "./Graph/AgeGroupChart";
import FamilySizeChart from "./Graph/FamilySizeChart";
import AllBeneficiaries from "./Graph/AllBeneficiariesChart";
import EducationByGenderChart from "./Graph/EducationChart";
import WashDashboard from "./WashGraph/WashDashboard";
import WashCards from "./WashGraph/WashCards";
import WaterSourceChart from "./WashGraph/WaterSourceChart";
import ToiletStatusChart from "./WashGraph/ToiletChart";
import FloodImpactChart from "./WashGraph/FloodImpactChart";
import HandwashingFacilityChart from "./WashGraph/HandWashingChart";
import TotalYearExpenditure from "./WashGraph/TotalYearExpenditureChart";
import SummaryTable from "./WashGraph/SummaryChart";
import HouseHoldDashboard from "./HouseHoldDashboard/HouseHoldDashboard";

import HouseHoldFilter from "./Graph/HouseHoldFilter";
import BusinessGrantsDashboard from "./BusinessGrants/BusinessGrantsDashboard";
import SchoolDashboard from "./SchoolAssessmentGraph/SchoolDashboard";
import HealthFacilityDashboard from "./HealthFacilityGraph/HealthFacilityDashboard";
import MPIDashboard from "./MPIDashboard/MPIDashboard";
import BoqsDashboard from "./Boqs/BoqsDashboard";

import { useSelector } from "react-redux";

const TabComponent = ({ sidebarVisible, filters }) => {
  const [activeTab, setActiveTab] = useState("household");

  const { user: loggedInUser } = useSelector((state) => state.auth);
  const permissions = loggedInUser?.user_permissions || [];

  // Define permission mapping
  const permissionTabs = [
    { id: "household", label: "Household", perm: "dashboard-household" },
    { id: "mpi", label: "MPI", perm: "dashboard-mpi" },
    { id: "wash", label: "Wash", perm: "dashboard-wash" },
    { id: "school", label: "School", perm: "dashboard-school" },
    {
      id: "health",
      label: "Health Facility",
      perm: "dashboard-health-facility",
    },
    {
      id: "boqs",
      label: "BOQ's",
      perm: ["dashboard-boq", "dashboard-boq-implementation", "dashboard-boq-monitoring"],
    },
    {
      id: "bg",
      label: "Business Grants",
      perm: [
        "dashboard-business-grant-sme",
        "dashboard-business-grant-micro",
        "dashboard-business-grant-corporate",
        "dashboard-business-grant-social-enterprise",
        "dashboard-business-grant-sedf-enterprise",
      ],
    },
  ];

  // Filter only tabs allowed for user
  const allowedTabs = permissionTabs.filter((tab) => {
    if (Array.isArray(tab.perm)) {
      return tab.perm.some((p) => permissions.includes(p));
    }
    return permissions.includes(tab.perm);
  });

  // Auto set first allowed tab if current is not allowed
  useEffect(() => {
    const currentTabAllowed = allowedTabs.some((t) => t.id === activeTab);
    if (!currentTabAllowed && allowedTabs.length > 0) {
      setActiveTab(allowedTabs[0].id);
    }
  }, [permissions]);

  if (allowedTabs.length === 0) {
    return (
      <div className="text-center mt-20 text-gray-500">
        You don’t have permission to view any dashboards.
      </div>
    );
  }

  return (
    <div
      className={`${
        sidebarVisible ? "lg:w-[80%]" : "lg:w-[95%]"
      } w-full transition-all duration-500 ease-in-out flex-1 h-auto lg:mx-[2rem] px-2 pt-[3rem] lg:pt-[5rem] lg:mb-[4rem] ${
        sidebarVisible ? "lg:ml-[16.5rem] ml-0" : "lg:ml-[5rem]"
      }`}
    >
      <div className="container mx-auto">
        {/* Tabs */}
        <div className="flex flex-wrap border-b border-white overflow-x-auto">
          {allowedTabs.map((tab) => (
            <button
              key={tab.id}
              className={`px-4 py-2 text-sm font-medium border-b-2 whitespace-nowrap transition-all duration-200 ${
                activeTab === tab.id
                  ? "text-black border-[#cba51f]"
                  : "text-gray-600 border-transparent hover:border-[#cba51f]"
              }`}
              onClick={() => setActiveTab(tab.id)}
              role="tab"
              aria-selected={activeTab === tab.id}
              aria-controls={`tab-${tab.id}`}
              id={`tab-${tab.id}-button`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div>
          {activeTab === "household" && (
            // <div id="tab-household" role="tabpanel">
            //   <div className="mb-6">
            //     <HouseHoldFilter />
            //     <DashboardCards />
            //   </div>

            //   {/* First Chart Row */}
            //   <div className="flex flex-col md:flex-row md:-mx-2 mb-8">
            //     <div className="w-full md:w-1/2 md:px-2 mb-4 md:mb-0">
            //       <AllBeneficiaries />
            //     </div>
            //     <div className="w-full md:w-1/2 md:px-2">
            //       <FamilySizeChart />
            //     </div>
            //   </div>

            //   {/* Second Chart Row */}
            //   <div className="flex flex-col md:flex-row md:-mx-2 mb-8">
            //     <div className="w-full md:w-1/2 md:px-2 mb-4 md:mb-0">
            //       <MaritalStatusChart />
            //     </div>
            //     <div className="w-full md:w-1/2 md:px-2">
            //       <GenderPieChart />
            //     </div>
            //   </div>

            //   {/* Third Chart Row */}
            //   <div className="flex flex-col md:flex-row md:-mx-2 mb-8">
            //     <div className="w-full md:w-1/2 md:px-2 mb-4 md:mb-0">
            //       <EducationByGenderChart />
            //     </div>
            //     <div className="w-full md:w-1/2 md:px-2">
            //       <AgeGroupChart />
            //     </div>
            //   </div>
            // </div>
            <div>
              <HouseHoldDashboard />
            </div>
          )}

          {activeTab === "mpi" && (
            <div id="tab-mpi" role="tabpanel">
              <MPIDashboard filters={filters} />
            </div>
          )}

          {activeTab === "wash" && (
            <div id="tab-wash" role="tabpanel">
              <WashDashboard />
            </div>
          )}

          {activeTab === "bg" && (
            <div id="tab-bg" role="tabpanel">
              <BusinessGrantsDashboard />
            </div>
          )}

          {activeTab === "school" && (
            <div id="tab-school" role="tabpanel">
              <SchoolDashboard />
            </div>
          )}

          {activeTab === "health" && (
            <div id="tab-health" role="tabpanel">
              <HealthFacilityDashboard />
            </div>
          )}

          {activeTab === "boqs" && (
            <div id="tab-bg" role="tabpanel">
              <BoqsDashboard />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TabComponent;
